import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var isFiltered = function isFiltered(propName, list) {
  return list.some(function (listItem) {
    return propName.includes(listItem);
  });
};

export var useSeparatedProps = function useSeparatedProps(props) {
  for (var _len = arguments.length, filters = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    filters[_key - 1] = arguments[_key];
  }

  var rest = {};
  var filtered = [];
  Object.entries(props).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        propName = _ref2[0],
        value = _ref2[1];

    var isRest = true;
    filters.forEach(function (filterProps, index) {
      if (!filtered[index]) filtered[index] = {};

      if (isFiltered(propName, filterProps)) {
        filtered[index][propName] = value;
        isRest = false;
      }
    });

    if (isRest) {
      rest[propName] = value;
    }
  });
  filtered.push(rest);
  return filtered;
};